var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-icon',{staticClass:"text-h1"},[_vm._v(" mdi-alert ")]),_c('div',{staticClass:"text-center"},[_vm._v(" Affichage non disponible : "+_vm._s(_vm.data.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }